import { mainPath } from "../../lib/mainPath";
import { requestsTemplates } from "../../lib/requestsTemplates";

export const post = (vacation) =>
  requestsTemplates.post(mainPath, "/vacations",vacation);
